<template>
  <v-dialog :value="true" persistent max-width="450">
    <v-card>
      <v-card-title class="headline">Deny Proof</v-card-title>

      <v-card-text>
        <p>Please enter the reason for denial below. Please remember that the person has already fulfilled their end of the bargin by posting to their feed.</p>
        <v-form ref="denyForm">
          <v-text-field v-model="denialReason" :disabled="denyRequestLoading" outlined label="Reason for denial" :rules="requiredRule" />
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :disabled="denyRequestLoading" color="darken-1" text @click="$emit('sway-offer-deny-modal-close')">Close</v-btn>
        <v-btn :loading="denyRequestLoading" color="primary darken-1" text @click="denySwayOffer()">Send</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from 'vue'
import { ApiService } from '@/services/index'
import validationRules from '@/utils/validation'

export default Vue.extend({
  name: 'SwayOfferDenyModal',

  props: {
    proofId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    denialReason: '',
    denyRequestLoading: false,
    requiredRule: validationRules.requiredRule,
  }),

  methods: {
    denySwayOffer() {
      if (!this.$refs.denyForm.validate()) return

      this.denyRequestLoading = true

      ApiService.put(`reverseFlow/proof/deny/${this.proofId}`, { denialReason: this.denialReason }).then(() => {
        this.$emit('sway-offer-deny-modal-proof-denied')
        this.$toast.success(`Proof denied`)

        this.denyRequestLoading = false
      })
    },
  },
})
</script>
